import { useParams } from 'react-router-dom';
import { useDataRoomQuery, useActiveLenderSummaryReportQuery } from '../../shared/hooks';
import { CerebroBreadcrumb, CerebroLink, CerebroPageContainer, CerebroText } from '../../shared/components';
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { sanitize } from 'dompurify';
import { CerebroApiEndpoints } from '../../shared/utils/api';

export const ActiveLenderSummaryReport: React.FC = () => {
	const { guid } = useParams<'guid'>();
	const dataRoomQuery = useDataRoomQuery(guid);
	const reportQuery = useActiveLenderSummaryReportQuery(guid, {
		enabled: dataRoomQuery.isSuccess,
		retry: false,
	});
	const isLoading = reportQuery.isLoading || reportQuery.isFetching;

	return (
		<CerebroPageContainer maxWidth="100%">
			<CerebroBreadcrumb>Lender Progress &gt; Active Summary Report</CerebroBreadcrumb>

			{isLoading && (
				<>
					<Skeleton height={60} />
					<Skeleton height={60} />
					<Skeleton height={60} />
					<Skeleton height={60} />
				</>
			)}

			{reportQuery.isSuccess && (
				<>
					<TableContainer sx={{ marginTop: 3 }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Lender Institution</TableCell>
									<TableCell>Last Completed Progress Stage</TableCell>
									<TableCell>Most Recent Note</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{reportQuery.data.map(summary => (
									<TableRow key={summary.id}>
										<TableCell>{summary.bankName}</TableCell>
										<TableCell>{summary.lastMilestoneCompleted}</TableCell>
										<TableCell>
											<div
												dangerouslySetInnerHTML={{
													__html: sanitize(summary.mostRecentNote ?? '<p></p>'),
												}}
											></div>
										</TableCell>
									</TableRow>
								))}
								{reportQuery.data.length == 0 && (
									<TableRow>
										<TableCell colSpan={3} sx={{ textAlign: 'center' }}>
											<CerebroText sx={{ paddingTop: 3, paddingBottom: 3 }}>
												There are currently no active lenders.
											</CerebroText>
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>

					<br />
					<CerebroLink
						href={CerebroApiEndpoints.DataRooms.DownloadActiveLenderSummaryReport(guid)}
						target="_blank"
						rel="noreferrer"
					>
						Download Report
					</CerebroLink>
				</>
			)}
		</CerebroPageContainer>
	);
};
